module.exports = __webpack_public_path__ + "img/60f4.f600e9ed.jpg";